import request from '@/utils/request'

let Equipment_classificationApi = {

  /*设备分类列表*/
  list(data) {
    return request._post('/shop/plus.equipment_classification.Index/index', data);
},
/*添加设备分类*/
add(data) {
    return request._post('/shop/plus.equipment_classification.Index/add', data);
},
/*修改设备分类*/
edit(data) {
    return request._post('/shop/plus.equipment_classification.Index/edit', data);
},
/*删除设备分类*/
del(data) {
    return request._post('/shop/plus.equipment_classification.Index/del', data);
},
/*设备分类详情*/
detail(data) {
  return request._post('/shop/plus.equipment_classification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.equipment_classification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.equipment_classification.Setting/getSetting', data, errorback);
    },
}
export default Equipment_classificationApi;



// WEBPACK FOOTER //
// ./src/api/equipment_classification.js